import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash } from 'react-icons/fa';
import './Bairros.css';

import API_BASE_URL from '../../../../config/api';

const Bairros = () => {
  const [bairros, setBairros] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    bairro: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);

  const carregarBairros = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/bairros`);
      if (!response.ok) {
        throw new Error('Erro ao buscar bairros');
      }
      const data = await response.json();
      const formatados = data.map((item) => ({
        id: item.id_bairro,
        bairro: item.nome_bairro,
        ativo: item.ativo
      }));
      setBairros(formatados);
    } catch (error) {
      console.error('Erro ao carregar bairros:', error);
      alert('Erro ao carregar bairros. Verifique a conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarBairros();
  }, []);

  const filteredBairros = bairros.filter(bairro =>
    bairro.bairro.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        nome_bairro: formData.bairro,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(`${API_BASE_URL}/bairros/${editingId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao atualizar bairro');
        }

        const atualizado = await response.json();

        setBairros(
          bairros.map((bairro) =>
            bairro.id === editingId
              ? {
                  id: atualizado.id_bairro,
                  bairro: atualizado.nome_bairro,
                  ativo: atualizado.ativo
                }
              : bairro
          )
        );
      } else {
        const response = await fetch(`${API_BASE_URL}/bairros`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao criar bairro');
        }

        const criado = await response.json();

        setBairros([
          ...bairros,
          {
            id: criado.id_bairro,
            bairro: criado.nome_bairro,
            ativo: criado.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar bairro:', error);
      alert('Erro ao salvar bairro. Verifique os dados e tente novamente.');
    }
  };

  const handleEdit = (bairro) => {
    setFormData({
      bairro: bairro.bairro,
      ativo: bairro.ativo
    });
    setEditingId(bairro.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este bairro?')) {
      try {
        const response = await fetch(`${API_BASE_URL}/bairros/${id}`, {
          method: 'DELETE'
        });

        if (!response.ok && response.status !== 204) {
          throw new Error('Erro ao excluir bairro');
        }

        setBairros(bairros.filter((bairro) => bairro.id !== id));
      } catch (error) {
        console.error('Erro ao excluir bairro:', error);
        alert('Erro ao excluir bairro. Tente novamente.');
      }
    }
  };

  const resetForm = () => {
    setFormData({ bairro: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const bairroSelecionado = bairros.find((b) => b.id === id);
    if (!bairroSelecionado) {
      return;
    }

    const novoAtivo = !bairroSelecionado.ativo;

    try {
      const response = await fetch(`${API_BASE_URL}/bairros/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nome_bairro: bairroSelecionado.bairro,
          ativo: novoAtivo
        })
      });

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do bairro');
      }

      setBairros(
        bairros.map((bairro) =>
          bairro.id === id ? { ...bairro, ativo: novoAtivo } : bairro
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status do bairro:', error);
      alert('Erro ao atualizar status do bairro. Tente novamente.');
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Bairros</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Bairro
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Bairro' : 'Cadastrar Bairro'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="bairro">Nome do Bairro *</label>
              <input
                type="text"
                id="bairro"
                value={formData.bairro}
                onChange={(e) => setFormData({...formData, bairro: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite o nome do bairro"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary">
                {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Pesquisar bairros..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading ? 'Carregando bairros...' : `${filteredBairros.length} registro(s) encontrado(s)`}
              </span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table bairros-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Bairro</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredBairros.map(bairro => (
                  <tr key={bairro.id}>
                    <td>{bairro.id}</td>
                    <td>{bairro.bairro}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={bairro.ativo}
                          onChange={() => handleToggleStatus(bairro.id)}
                          id={`toggle-${bairro.id}`}
                        />
                      </div>
                    </td>
                    <td className="acoes-col">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(bairro)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(bairro.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Bairros;
